import { alpha } from "@mui/material/styles";

export const ui = {
  page: "#f7f8fa",
  panel: "#ffffff",
  border: "#e6e9ee",
  borderStrong: "#d9dee7",
  text: "#182230",
  muted: "#667085",
  subtle: "#98a2b3",
  soft: "#f8fafc",
  danger: "#b42318",
};

export const inputSx = {
  "& .MuiInputLabel-root": {
    fontSize: 11.1,
    color: ui.muted,
    transform: "translate(14px, 7px) scale(1)",
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    transform: "translate(14px, -7px) scale(0.75)",
  },
  "& .MuiOutlinedInput-root": {
    minHeight: 34,
    borderRadius: 0.9,
    bgcolor: "#fff",
    fontSize: 12.1,
    transition: "box-shadow 150ms ease, border-color 150ms ease",
    "& fieldset": { borderColor: ui.borderStrong },
    "&:hover fieldset": { borderColor: "#c4cad3" },
    "&.Mui-focused": {
      boxShadow: theme =>
        `0 0 0 3px ${alpha(theme.palette.primary.main, 0.075)}`,
    },
    "&.Mui-focused fieldset": {
      borderWidth: 1,
      borderColor: "primary.main",
    },
  },
  "& .MuiOutlinedInput-input": {
    height: 34,
    boxSizing: "border-box",
    px: 1.05,
    py: 0,
    lineHeight: "34px",
    transform: "translateY(-1px)",
  },
  "& .MuiSelect-select": {
    minHeight: "34px !important",
    height: "34px !important",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    py: "0 !important",
    transform: "translateY(-1px)",
  },
  "& .MuiOutlinedInput-root.MuiInputBase-multiline": {
    minHeight: 64,
    alignItems: "flex-start",
    py: 0.7,
  },
  "& .MuiOutlinedInput-root.MuiInputBase-multiline .MuiOutlinedInput-input": {
    height: "auto",
    minHeight: 48,
    py: 0,
    lineHeight: 1.45,
    transform: "none",
  },
  "& .MuiFormHelperText-root": {
    mt: 0.35,
    mx: 0.1,
    color: ui.subtle,
    fontSize: 9.6,
  },
};

export const compactInputSx = {
  ...inputSx,
  "& .MuiInputLabel-root": {
    fontSize: 10.8,
    color: ui.muted,
    transform: "translate(14px, 6px) scale(1)",
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    transform: "translate(14px, -7px) scale(0.75)",
  },
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    minHeight: 32,
    fontSize: 11.8,
  },
  "& .MuiOutlinedInput-input": {
    height: 32,
    boxSizing: "border-box",
    px: 1,
    py: 0,
    lineHeight: "32px",
    transform: "translateY(-1px)",
  },
  "& .MuiSelect-select": {
    minHeight: "32px !important",
    height: "32px !important",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    py: "0 !important",
    transform: "translateY(-1px)",
  },
};

export const compactMultilineSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root.MuiInputBase-multiline": {
    minHeight: 42,
    alignItems: "flex-start",
    py: 0.45,
  },
  "& .MuiOutlinedInput-root.MuiInputBase-multiline .MuiOutlinedInput-input": {
    height: "auto",
    minHeight: 28,
    py: 0,
    lineHeight: 1.4,
    transform: "none",
  },
};

export const panelSx = {
  p: { xs: 1, sm: 1.1 },
  border: `1px solid ${ui.border}`,
  borderRadius: 1.35,
  bgcolor: "#fff",
  boxShadow:
    "0 1px 2px rgba(16,24,40,.025), 0 8px 22px rgba(16,24,40,.016)",
};

export const dividerSx = { borderColor: ui.border };

export const dialogButtonBaseSx = {
  minHeight: 32,
  borderRadius: 1,
  textTransform: "none",
  fontSize: 10.8,
};
